module.exports = __webpack_public_path__ + "static/img/img12.275a1f53.png";